import { render, staticRenderFns } from "./hidrocarburos.vue?vue&type=template&id=a2094e34"
import script from "./hidrocarburos.vue?vue&type=script&lang=js"
export * from "./hidrocarburos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports